import type { Time } from '../typings'

// disables filtering on autocomplete
export const filterOptions = (times: (Time | string)[]) => times
